// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var NodeId = function (x) {
    return x;
};
var semigroupNodeId = Data_Semigroup.semigroupString;
var newtypeNodeId = new Data_Newtype.Newtype(function (n) {
    return n;
}, NodeId);
var showNodeId = new Data_Show.Show(Data_Newtype.unwrap(newtypeNodeId));
var eqNodeId = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordNodeId = new Data_Ord.Ord(function () {
    return eqNodeId;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordString)(x)(y);
    };
});
var encodeJsonNodeId = Data_Argonaut_Encode_Class.encodeJsonJString;
var defaultNodeId = new Data_Default.Default("");
var decodeJsonNodeId = Data_Argonaut_Decode_Class.decodeJsonString;
var _NodeId = function (dictStrong) {
    return Lunarbox_Data_Lens.newtypeIso(newtypeNodeId)(dictStrong);
};
module.exports = {
    NodeId: NodeId,
    "_NodeId": _NodeId,
    eqNodeId: eqNodeId,
    ordNodeId: ordNodeId,
    newtypeNodeId: newtypeNodeId,
    encodeJsonNodeId: encodeJsonNodeId,
    decodeJsonNodeId: decodeJsonNodeId,
    semigroupNodeId: semigroupNodeId,
    defaultNodeId: defaultNodeId,
    showNodeId: showNodeId
};
